import { IconProps } from 'src/utils/icon';

const ReportsIcon: React.FC<IconProps> = ({
  size = 1,
  fill = 'var(--black)',
}) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 11 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.41667 3.98438V0H0.6875C0.30651 0 0 0.313477 0 0.703125V14.2969C0 14.6865 0.30651 15 0.6875 15H10.3125C10.6935 15 11 14.6865 11 14.2969V4.6875H7.10417C6.72604 4.6875 6.41667 4.37109 6.41667 3.98438ZM11 3.57129V3.75H7.33333V0H7.50807C7.69141 0 7.86615 0.0732422 7.99505 0.205078L10.7995 3.07617C10.9284 3.20801 11 3.38672 11 3.57129Z"
      fill={fill}
    />
  </svg>
);

export default ReportsIcon;
